// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_Fsk","cls2":"AuthorsCard-cls2_qfd AuthorsCard-cls1_Fsk"};